import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["shouldHighlight"];
import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';

// HACK: This weird wrapper is purely to ensure that we don't pass shouldHighlight
// down to the underlying div. If we upgraded styled-components to support either
// transient props or the ignoreProps api we could use that, but sadly our repackage
// does not support it.
import { jsx as _jsx } from "react/jsx-runtime";
const Div = _ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
};
export const HEADER_LEFT_BORDER_WIDTH = 2;
const HeaderLeftBorder = styled(Div).withConfig({
  displayName: "HeaderLeftBorder",
  componentId: "sc-1tdadkb-0"
})(["flex-shrink:0;border-left:", "px solid transparent;background:none;height:100%;", ""], HEADER_LEFT_BORDER_WIDTH, ({
  shouldHighlight
}) => shouldHighlight ? `border-color: ${CALYPSO};` : '');
export default HeaderLeftBorder;